import { ReactElement } from 'react';
import {
  Box,
  Typography,
  Radio,
  FormControlLabel,
  RadioGroup,
} from '@mui/material';
import {
  AppFormikCheckboxGroup,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

type QuestionType = 'SelectOne' | 'SelectMany' | 'ShortText' | 'LongText';

export interface Question {
  id: string;
  type: QuestionType;
  text: string;
  options?: string[];
}

interface Props {
  question: Question;
}

export default function QuestionPreview({ question }: Props): ReactElement {
  const validOptions = (question.options ?? []).filter((o) => o.trim() !== '');

  console.log(question, 'QTN');

  return (
    <Box mb={3}>
      <Typography variant="body1" mb={1}>
        {question.text || 'Untitled question'}
      </Typography>

      {question.type === 'SelectOne' && (
        <RadioGroup>
          {validOptions.map((opt, i) => (
            <FormControlLabel
              disabled
              key={i}
              value={opt}
              control={<Radio size="small" />}
              label={<Typography variant="body1">{opt}</Typography>}
            />
          ))}
        </RadioGroup>
      )}

      {question.type === 'SelectMany' && (
        <AppFormikCheckboxGroup
          name="selected_options"
          outerLabel=""
          options={validOptions.map((opt) => ({ label: opt, value: opt }))}
          row
          disabled
        />
      )}

      {question.type === 'ShortText' && (
        <AppFormikTextField
          name="name"
          outerLabel
          disabled
          placeholder="Enter your answer..."
        />
      )}

      {question.type === 'LongText' && (
        <AppFormikTextArea name="description" rows={3} />
      )}
    </Box>
  );
}
